import React from 'react';
import {
  core_apimessages_Money as Money,
} from '../../src/schemas/rql';
import CartApplePayButton from './CartApplePayButton';
import experiments from '@reverbdotcom/commons/src/experiments';
import { useExpEnabled } from '@reverbdotcom/commons/src/user_hooks';
import { findMerchantId, merchantName } from './checkoutApplePay';
import { ApplePayConfig } from './useCartApplePay';

interface Props {
  checkoutBundlingId: string;
  amountTotal: Money;
  adyenCheckoutPaymentMethodsConfig: string;
}

export function CartBundleFooterApplePayButton(props: Props) {
  const inPaypalButtonRollout = useExpEnabled(experiments.PAYPAL_CHECKOUT_BUTTON);
  const variant = inPaypalButtonRollout ? 'white-outlined-express' : 'white-outlined';

  const applePayConfig: ApplePayConfig = {
    merchantId: findMerchantId(JSON.parse(props.adyenCheckoutPaymentMethodsConfig)),
    merchantName: merchantName(),
  };

  return (
    <div className="checkout-cart-footer__button checkout-cart-footer__button--apple-pay">
      <CartApplePayButton
        variant={variant}
        checkoutBundlingId={props.checkoutBundlingId}
        amountTotal={props.amountTotal}
        applePayConfig={applePayConfig}
        tracking={{
          displayStyle: 'default',
        }}
      />
    </div>
  );
}
